export default e => ({
  title: e.title,
  from: {
    month: e.from.month,
    year: e.from.year,
  },
  to: {
    month: e.to.month,
    year: e.to.year,
  },
});



// WEBPACK FOOTER //
// ./src/transforms/CleanTitleYears.js